export const onTrackingActions = async (trackingName: string) => {
  await window.analytics.track(trackingName)
}
